import { render, staticRenderFns } from "./HighStateTypeDashboard.vue?vue&type=template&id=012253dc&scoped=true"
import script from "./HighStateTypeDashboard.vue?vue&type=script&lang=js"
export * from "./HighStateTypeDashboard.vue?vue&type=script&lang=js"
import style0 from "./HighStateTypeDashboard.vue?vue&type=style&index=0&id=012253dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012253dc",
  null
  
)

export default component.exports